var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ads-wrapper"},[_c('a',{style:({'background-image': 'url('+_vm.row.bg_img+')'}),attrs:{"href":_vm.row.url,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.row.overlay_img,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }